<template>
  <li class="item">
    <div
      class="header"
      :style="{
        'background-image': `url(${require(`assets/images/${bgName}.png`)})`
      }"
    >
      {{ complainInfo.type }}
    </div>
    <div class="body">
      <div class="charts">
        <div class="title">
          <p class="text">投诉来源分布</p>
          <p class="sub-text">按照投诉来源统计</p>
          <el-select
            class="type"
            v-model="complainInfo.source"
            @change="handleChange"
          >
            <el-option label="全部" value="" />
            <el-option label="电话" value="电话" />
            <el-option label="网络" value="网络" />
            <el-option label="信件" value="信件" />
            <el-option label="走访" value="走访" />
          </el-select>
        </div>
        <Echarts :echartsOption="complainInfo.echartsOption" />
      </div>
      <div class="content-list">
        <div class="title">
          <p class="text">投诉列表</p>
          <p class="sub-text">自治区内{{ complainInfo.type }}投诉列表</p>
        </div>
        <div class="table-list">
          <el-table :data="complainInfo.tableList">
            <el-table-column
              label="信息编号"
              prop="information_index"
              width="110px"
            />
            <el-table-column label="投诉来源" prop="source" width="80px" />
            <el-table-column
              label="被投诉产品名称"
              prop="complain_product_name"
              show-overflow-tooltip
            />
            <el-table-column
              label="转交办时间"
              prop="transmit_time"
              width="100px"
            />
            <el-table-column
              label="办结时间"
              prop="transmit_com_time"
              width="100px"
            />
          </el-table>
        </div>
        <el-pagination
          class="pagination"
          layout="total, prev, pager, next, jumper"
          :total="complainInfo.pageInfo.total"
          :current-page="complainInfo.pageInfo.currentPage"
          @current-change="currentChange"
        />
      </div>
      <div class="border"></div>
    </div>
  </li>
</template>

<script>
import Echarts from 'components/echarts/echarts';

export default {
  props: {
    bgName: {
      type: String,
      default: 'bg-circle'
    },
    complainInfo: Object
  },
  methods: {
    currentChange(page) {
      this.$emit('currentChange', page);
    },
    handleChange() {
      this.$emit('sourceChange');
    }
  },
  components: {
    Echarts
  }
};
</script>

<style lang="stylus" scoped>
.el-table
  font-size 12px
.item
  margin-bottom 21px
  .header
    background-size cover
    height 74px
    line-height 60px
    padding-left 21px
    font-size 18px
    border-radius 8px 8px 0 0
  .body
    position relative
    background #fff
    border-radius 8px
    transform translate(0, -16px)
    overflow hidden
    padding 0 20px
    height 396px
    .title
      border-bottom 1px solid rgba(206, 219, 239, .5)
      padding 12px 0
      .text
        color #000
        font-size 14px
        margin-bottom 6px
      .sub-text
        color #666666
        font-size 12px
      .type
        float right
        margin-top -37px
        width 80px
        height 32px
        margin-right 30px
        >>>.el-input__inner
          height 32px
          line-height 32px
        >>>.el-input__icon
          line-height 32px
    .charts
      width 551px
      float left
    .content-list
      float left
      width 709px
      position relative
      height 100%
      .title
        padding-left 30px
      .table-list
        margin 20px 20px 20px 30px
      .pagination
        position absolute
        bottom 30px
        right 20px
    .border
      position absolute
      left 571px
      top 0
      bottom 0
      width 1px
      background rgba(206, 219, 239, .5)
</style>
